import { useTranslate } from "common/utilities/useTranslate";
import { UpgradeModal } from "domains/modal/components/UpgradeModal";

export const CreateMapUpgradeModal = () => {
  const translate = useTranslate();

  return (
    <UpgradeModal
      buttonText={translate("app.message_banner.upgrade.button.2")}
      buttonTrackMeta={{ page: "Create", subpage: "Create custom map" }}
      message={translate("app.create.upgrade_text")}
      title={translate("app.create.upgrade.title")}
    />
  );
};
